import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup } from '@angular/forms';
import { ProductVariantDetailComponent } from '@vendure/admin-ui/catalog';
import {
  CustomDetailComponent,
  DataService,
  SharedModule,
} from '@vendure/admin-ui/core';
import { ProductVariant } from '@vendure/core';
import { Observable, switchMap, tap } from 'rxjs';

declare module '@vendure/core/dist/entity/custom-entity-fields' {
  // use an interface instead of a type to enable declaration merging
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface CustomProductVariantFields {
    costPrice?: number | null;
  }
}

type CustomFieldsFGType = FormGroup<{
  leadTime: FormControl<number | null>;
  costPrice: FormControl<number | null>;
}>;

@Component({
  templateUrl: './price-calculation.component.html',
  standalone: true,
  providers: [],
  imports: [SharedModule],
})
export class PriceCalculationComponent
  implements CustomDetailComponent, OnInit
{
  private dataService = inject(DataService);
  private productVariantDetailComponent = inject(ProductVariantDetailComponent);

  // only needed, since without it, the `takeUntilDestroyed` would only work during member init and ctor, not methods like `ngOnInit`
  private destroyRef = inject(DestroyRef);

  entity$: Observable<ProductVariant>;

  detailForm = this.productVariantDetailComponent.detailForm;

  currencyCode$ = this.dataService.settings
    .getActiveChannel()
    .mapStream((data) => data.activeChannel.defaultCurrencyCode);

  protected customFieldsFG!: CustomFieldsFGType;

  ngOnInit() {
    this.customFieldsFG = this.detailForm.controls
      .customFields as unknown as CustomFieldsFGType;

    this.entity$
      .pipe(
        tap((pVariant) => {
          this.customFieldsFG.patchValue({
            costPrice: pVariant.customFields.costPrice ?? 0,
          });
        }),
        switchMap(
          (data) =>
            this.dataService.product.getProduct(`${data.product.id}`).single$,
        ),
        tap((productWithVariantsQuery) => {
          // @ts-expect-error customFields not typed here
          if (productWithVariantsQuery.product.customFields.isFlowtechProduct) {
            this.customFieldsFG.controls.costPrice.disable();
          }
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
